








































































/* eslint-disable vue/prop-name-casing */
import Vue from 'vue'
import { IBadge, IProductContentDataMedia } from '@/interfaces/product'

export default Vue.extend({
  name: 'Item',
  props: {
    product_id: {
      type: Number,
      default: 99999,
      required: true
    },
    title: {
      type: String,
      default: '商品',
      required: true
    },
    price_text: {
      type: String,
      default: '',
      required: true
    },
    del_price_text: {
      type: String,
      default: '',
      required: true
    },
    media: {
      type: Object as ()=> IProductContentDataMedia,
      default: () => ({ type: -1, url: undefined, dest_url: undefined }),
      required: true
    },
    badge: {
      type: Object as ()=> IBadge,
      default: () => ({ color: 'F2994A', text: '熱銷' }),
      required: true
    }
  },
  data () {
    return {
      imageUrl: '' as string | undefined,
      fallbackImage: 'https://fakeimg.pl/600x600/?text=圖片&font=noto'
    }
  },
  computed: {
    discountClassText (): string {
      return `nu-item-price${this.isDiscount ? '-discount' : ''}`
    },
    isDiscount () : boolean {
      return this.price_text.length > 0 && this.del_price_text.length > 0
    },
    getImageUrl (): string {
      return typeof this.imageUrl === 'string' ? this.imageUrl : this.fallbackImage
    }
  },
  created () {
    if (this.media && this.media.url) {
      this.imageUrl = this.media.url
    } else this.imageUrl = undefined
  },
  methods: {
    onLoadingImageFailed () {
      this.imageUrl = this.fallbackImage
    },
    onProductClicked () {
      if (this.$route.query.parent !== undefined) {
        this.$store.commit('info/SET_ACTIVE', {
          activeCategory: this.$route.query.parent,
          activeSubCategory: this.$route.query.category,
          activeProduct: null
        })
        this.$store.commit('info/SET_ROUTE_HISTORY', [this.$route.query.parent, this.$route.query.category])
      } else {
        this.$store.commit('info/SET_ACTIVE', {
          activeCategory: this.$route.query.category || '0',
          activeSubCategory: null,
          activeProduct: null
        })
        this.$store.commit('info/SET_ROUTE_HISTORY', [this.$route.query.category || '0', undefined])
      }
      // this.$router.push({ name: 'Product', params: { productId: this.product_id.toString() } })
    }
  }
})
